import { useEffect } from 'react';

/**
 * Hook for tracking navigation between pages
 * @param currentPage - Current page identifier
 */
export const useNavigationTracking = (currentPage: string) => {
  useEffect(() => {
    const mountTime = performance.now();
    
    // Check if there was a recent navigation from KYP search
    const referrer = document.referrer;
    const isFromKypSearch = referrer.includes('/kyp-search') || 
                           sessionStorage.getItem('lastPage') === 'kyp-search';
    
    if (isFromKypSearch) {
      console.log(`PERF:${currentPage}: Navigated from KYP Search page`);
      
      // Check if there was a recent wishlist addition
      const lastWishlistAddTime = sessionStorage.getItem('lastWishlistAddTime');
      if (lastWishlistAddTime) {
        const timeSinceAdd = mountTime - parseInt(lastWishlistAddTime);
        console.log(`PERF:${currentPage}: Time since last wishlist addition: ${timeSinceAdd.toFixed(2)}ms`);
      }
    }
    
    // Store current page for future reference
    sessionStorage.setItem('lastPage', currentPage);
  }, [currentPage]);
};